export const isTruncated = ({ scrollWidth, clientWidth }: HTMLSpanElement): boolean => scrollWidth > clientWidth;
